const methods = {
    isEmpty:(value)=>{
        if(value == "" || value == null || value == undefined || value == 'null'){
            return true
        }

        return false;
    }
}

export default {
    install(Vue){
        Vue.prototype.$isEmpty = methods.isEmpty;
    }
}


// WEBPACK FOOTER //
// ./src/plugins/globalFunc.js